import IconDownArrow from '@material-ui/icons/KeyboardArrowDown'
import React, { ReactNode, useEffect, useState } from 'react'
import { classes } from '../../../utils/css'
import styles from './AppSideBar.module.css'

export type SideBarMenuItemProps = {
  label: ReactNode
  icon?: ReactNode
  level?: string | number
  sideBarOpen?: boolean
  menuOpen?: string
  subMenu?: SideBarMenuItemProps[]
  autoClose?: boolean
  onSelectedMenu?: (event: string) => void
  onClick?: () => void
  href?: string
}

function SideBarMenuItem({
  label,
  icon,
  level = 0,
  menuOpen = '',
  sideBarOpen = false,
  subMenu,
  autoClose = false,
  onSelectedMenu,
  onClick,
  href
}: SideBarMenuItemProps): JSX.Element {
  const [open, setOpen] = useState(false)
  useEffect(() => {
    !autoClose ? setOpen(menuOpen === level) : undefined
  }, [menuOpen])
  return subMenu && subMenu.length > 0 ? (
    <div
      className={styles.sideBarMenuContainer}
      onMouseLeave={() => {
        setOpen((open) => (autoClose ? false : open))
      }}
    >
      <a
        className={classes(styles.sideBarMenu)}
        onClick={() => {
          setOpen((open) => !open)
          onClick && onClick()
          onSelectedMenu ? onSelectedMenu(`${level}`) : undefined
        }}
      >
        {icon ? icon : undefined}
        <div className={sideBarOpen ? styles.fadeShow : styles.fadeHide}>
          {sideBarOpen ? label : undefined}
          {sideBarOpen ? (
            <IconDownArrow
              color='secondary'
              className={classes(
                styles.sideBarArrowIcon,
                open ? styles.open : ''
              )}
            />
          ) : undefined}
        </div>
      </a>
      <div
        className={classes(
          styles.sideBarMenuItems,
          open ? styles.open : styles.closed
        )}
      >
        {subMenu.map((item, key) => (
          <SideBarMenuItem
            {...{ ...item, sideBarOpen: sideBarOpen }}
            key={key}
            level={`${level}-${key}`}
            onSelectedMenu={(event) => {
              onSelectedMenu ? onSelectedMenu(event) : undefined
            }}
          />
        ))}
      </div>
    </div>
  ) : (
    <a
      className={classes(
        styles.sideBarMenuContainer,
        `${level}`.includes('-') ? styles.sideBarMenuItem : styles.sideBarItem
      )}
      href={href}
      onClick={(event) => {
        event.preventDefault()
        setOpen((open) => !open)
        onClick && onClick()
        onSelectedMenu ? onSelectedMenu(`${level}`) : undefined
      }}
    >
      {icon ? icon : undefined}
      <div className={sideBarOpen ? styles.fadeShow : styles.fadeHide}>
        {sideBarOpen ? label : undefined}
      </div>
    </a>
  )
}
type SideBarProps = {
  menuOptions: SideBarMenuItemProps[]
  autoClose?: boolean
  stayOpen?: boolean
  onSelectedMenu?: (event: string) => void
  isMobile?: boolean
}
function SideBar({
  menuOptions,
  autoClose = true,
  stayOpen = false,
  isMobile = false,
  onSelectedMenu = () => {}
}: SideBarProps): JSX.Element {
  const [sideBarOpen, setSideBarOpen] = useState(stayOpen || isMobile)
  const [menuSelected, setMenuSelected] = useState<string | undefined>(
    undefined
  )
  useEffect(() => {
    setSideBarOpen(stayOpen)
  }, [stayOpen, isMobile])
  return (
    <div
      data-testid='sidebar'
      className={classes(
        styles.sideBar,
        sideBarOpen ? styles.open : styles.closed,
        isMobile ? styles.mobile : ''
      )}
      onMouseOver={() => {
        setSideBarOpen(true)
      }}
      onMouseLeave={() => {
        setSideBarOpen(stayOpen)
      }}
    >
      {menuOptions && menuOptions.length > 0
        ? menuOptions.map((item, key) => (
            <SideBarMenuItem
              {...item}
              autoClose={autoClose}
              level={key}
              menuOpen={menuSelected}
              sideBarOpen={sideBarOpen}
              key={key}
              onSelectedMenu={(event) => {
                setMenuSelected(event)
                onSelectedMenu(event)
              }}
            />
          ))
        : undefined}
    </div>
  )
}

export default SideBar
